import { createContext, useContext, useState, useEffect } from 'react';
import { authAPI } from '@/lib/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem('token');
    const storedUser = localStorage.getItem('user');
    const adminFlag = localStorage.getItem('isAdmin');
    
    if (token && storedUser) {
      setUser(JSON.parse(storedUser));
      setIsAdmin(adminFlag === 'true');
    }
    setLoading(false);
  }, []);

  const login = async (udiseCode, password) => {
    const response = await authAPI.login({ udise_code: udiseCode, password });
    const { token, user: userData } = response.data;
    
    localStorage.setItem('token', token);
    localStorage.setItem('user', JSON.stringify(userData));
    localStorage.removeItem('isAdmin');
    
    setUser(userData);
    setIsAdmin(false);
    return userData;
  };

  const adminLogin = async (email, password) => {
    const response = await authAPI.adminLogin({ email, password });
    const { token } = response.data;
    
    localStorage.setItem('token', token);
    localStorage.setItem('isAdmin', 'true');
    localStorage.setItem('user', JSON.stringify({ email, role: 'admin' }));
    
    setUser({ email, role: 'admin' });
    setIsAdmin(true);
    return response.data;
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    localStorage.removeItem('isAdmin');
    setUser(null);
    setIsAdmin(false);
  };

  const refreshUser = async () => {
    try {
      const response = await authAPI.getMe();
      setUser(response.data);
      localStorage.setItem('user', JSON.stringify(response.data));
    } catch (error) {
      logout();
    }
  };

  return (
    <AuthContext.Provider value={{ user, loading, isAdmin, login, adminLogin, logout, refreshUser, setUser }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};
